
import { PropSync, Watch, Ref, Mixins, Component } from "vue-property-decorator";
import loading from "@/mixins/loading";
import { ElForm } from "element-ui/types/form";
import { getMerchantList, presCategoryTypeList } from "@/api/prescriptionDb";
import deepCopy from "@/utils/deepCopy";
import { saveCareProduct } from "@/api/product";

const initFormData = {
  codeNumber: "",
  merchantId: "",
  presTypeId: 2,
  presCategoryId: "",
  qrCodeId: "",
  qrCodeName: "",
};

@Component({ name: 'productCode-components-addProduct' })
export default class AddProduct extends Mixins(loading) {
  @PropSync("visible") dialogVisible !: boolean;
  @Ref("validateForm") validateForm !: ElForm;

  allMerchantList = [{ "id": 0, "name": "默认产品" }];
  presTypeList = [{
    "id": 1,
    "name": "项目产品库",
    "categoryType": 0
  }];
  productNameOptions = [];
  presCategoryList = [];
  formData = {
    merchantId: "",
    presTypeId: 2,
    presCategoryId: "",
    qrCodeId: "",
    codeNumber: 0,
    remark: "",
    qrCodeName: "",
    createdBy: "",
    productName: "",
  };
  rules = {
    merchantId: [{ required: true, message: "请选择品牌", trigger: "change" }],
    presTypeId: [{ required: true, message: "请选择产品类型", trigger: "change" }],
    presCategoryId: [{ required: true, message: "请选择产品分类", trigger: "change" }],
    qrCodeId: [{ required: true, message: "请选择产品名称", trigger: "change" }],
    codeNumber: [
      { required: true, message: '请输入编码数量', trigger: 'blur' },
      { type: 'number', message: '请输入正整数', trigger: 'blur' },
      {
        validator(rule, value, callback) {
          if (Number.isInteger(Number(value)) && Number(value) > 0) {
            callback();
          } else {
            callback(new Error("请输入正整数"));
          }
        },
        trigger: 'blur',
      }
    ]
  };

  presCategoryIdChange() {
    this.formData.qrCodeId = "";
    this.productNameOptions = [];
  }

  // 查询服务商品牌列表（包含养身帮）
  getAllMerchants() {
    getMerchantList({ pageNum: 1, isEnable: 1, pageSize: 100000 }).then((res) => {
      this.allMerchantList = [{ "id": 0, "name": "默认产品" }, ...res.data.list];
    });
  }

  // 通过品牌方查询产品类型
  getPresType() {
    // 获取全部一级分类
    presCategoryTypeList({ categoryType: 0, parentId: 0 }).then((res) => {
      this.presTypeList = res.data;
    });
  }

  // 通过品牌方和产品类型查询产品分类菜单
  getPresCategory() {
    let parentId = this.formData.presTypeId;
    let merchantId = this.formData.merchantId;
    if (!parentId) {
      return;
    }
    presCategoryTypeList({ categoryType: 1, parentId, merchantId }).then((res) => {
      this.presCategoryList = res.data;
    });
  }

  getProductNameOptions() {
    if (!this.formData.presCategoryId) return;
    const params = {
      categoryType: 2,
      parentId: this.formData.presCategoryId,
      merchantId: this.formData.merchantId || 0,
    }
    presCategoryTypeList(params).then((res) => {
      this.productNameOptions = res.data;
    })
  }

  onFormMerchantChanged($event) {
    if ($event) {
      this.rules.qrCodeId = [];
    } else {
      this.rules.qrCodeId = [{ required: !this.formData.merchantId, message: "请选择产品", trigger: "change" }];
    }
    this.formData.presCategoryId = "";
    this.presCategoryList = [];
    this.formData.qrCodeId = "";
  }

  dialogClose() {
    this.formData = deepCopy(initFormData);
    this.validateForm?.resetFields();
    this.allMerchantList = [{ "id": 0, "name": "默认产品" }];
    this.presCategoryList = [];
    this.dialogVisible = false;
  }

  dialogConfirm() {
    this.validateForm.validate().then(() => {
      this.showLoading();
      this.formData.createdBy = this.$store.getters.userinfo.username;
      this.formData.remark = this.formData.remark?.trim();
      this.formData.qrCodeName = this.productNameOptions?.find((el) => el.id == this.formData.qrCodeId)?.name;
      for (let presCate of this.presCategoryList) {
        if (presCate.id == this.formData.presCategoryId) {
          this.formData.productName = presCate.name;
          break;
        }
      }
      // 品牌方，如果没有选择产品，就把产品分类的填过来
      if (this.formData.merchantId && !this.formData.qrCodeId) {
        this.formData.qrCodeName = this.formData.productName;
      }
      if (!this.formData.productName || this.formData.productName.length == 0) {
        this.$message.error('数据异常，请选择正确的产品分类');
        return;
      }

    console.log(this.formData);
      saveCareProduct(this.formData).then(res => {
        this.dialogClose();
        this.$emit("syncList");
      }).finally(() => {
        this.hideLoading();
      });
    })
}

@Watch("dialogVisible")
dialogVisibleChange(val) {
  if (!val) return;
  this.getAllMerchants();
  this.getPresType();
}
}
